/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Preview_LabelInputs */

const en_highlight_settings_preview_label = /** @type {(inputs: Highlight_Settings_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview of highlighting`)
};

const es_highlight_settings_preview_label = /** @type {(inputs: Highlight_Settings_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa del resaltado`)
};

/**
* | output |
* | --- |
* | "Preview of highlighting" |
*
* @param {Highlight_Settings_Preview_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_preview_label = /** @type {((inputs?: Highlight_Settings_Preview_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Preview_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_preview_label(inputs)
	return en_highlight_settings_preview_label(inputs)
});